import React from "react";
import { useInstallPrompt } from "./InstallPromptContext";

export default function InstallPWAButton({ className = "", children }) {
  const { deferredPrompt, setDeferredPrompt, isInstalled } = useInstallPrompt();

  if (isInstalled || !deferredPrompt) return null;

  const onClick = async () => {
    try {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice; // accepted | dismissed
      console.log("Install outcome:", outcome);
    } finally {
      setDeferredPrompt(null); // clear either way
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={className || "px-3 py-2 rounded bg-sky-600 text-white font-semibold"}
      aria-label="Install PTfinderNow"
    >
      {children ?? "Install PTfinderNow"}
    </button>
  );
}
